import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
} from '@angular/core';

@Component({
  selector: 'mj-dropdown-filter',
  templateUrl: './dropdownfilter.component.html',
  styleUrls: ['./dropdownfilter.component.scss'],
})
export class DropdownFilterComponent implements OnInit {
  @Input() fields: {} = {};
  @Input() startValue: string = '';
  @Input() startIcon: string = 'fa-users';
  @Output() onFilter = new EventEmitter<number>();

  // Internal fields
  public filterValue: any = 'default';
  public showFilter: boolean;
  public elementRef;
  public filterObject: {} = {};

  constructor(element: ElementRef) {
    this.showFilter = false;
    this.elementRef = element;
  }

  ngOnInit() {
    this.setFilterObject();
  }

  @HostListener('document:click', ['$event'])
  public onClick(event) {
    const clickedComponent = event.target;

    if (!this.elementRef.nativeElement.contains(clickedComponent)) {
      // or some similar check
      this.showFilter = false;
    }
  }

  public toggleList() {
    this.showFilter = !this.showFilter;
  }

  public setFilterValue(value) {
    this.onFilter.emit(value);
    this.filterValue = value;

    this.setFilterObject();
    this.toggleList();
  }

  public setFilterObject() {
    const id = this.filterValue;

    if (id === 'default') {
      this.filterObject = { text: this.startValue, icon: this.startIcon };
      return;
    }
    this.filterObject = this.fields[id];
  }
}
